import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface AssessmentScoresHistoryResponse {
  assessment_scores_history: AssessmentScoresHistoryData[]
}

export type AssessmentScoresHistoryData = {
  student_id: number
  avg_score?: number
  quizzes_taken?: number
  total_attempts?: number
}

export async function assessmentScoresHistory(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductMs,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<AssessmentScoresHistoryData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('assessment_scores_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<AssessmentScoresHistoryResponse>(url, query)
  if (!data) return null
  if (data.assessment_scores_history.length === 0) return null

  return data.assessment_scores_history
}
